import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=6c4d8baa&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=6c4d8baa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4d8baa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c4d8baa')) {
      api.createRecord('6c4d8baa', component.options)
    } else {
      api.reload('6c4d8baa', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=6c4d8baa&scoped=true", function () {
      api.rerender('6c4d8baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/footer.vue"
export default component.exports